<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrIsoDuzelticiFaaliyet from "@/models/StrIsoDuzelticiFaaliyet"; import Swal from "sweetalert2";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formcheckbox from "@/router/views/FormComponet/formcheckbox.vue"; 
import forminput from "@/router/views/FormComponet/forminput.vue";
import formdate from "@/router/views/FormComponet/formdate.vue";
import tableheader from "../tableheader/index";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
export default {
  mixins: [Api, Sabit, StrIsoDuzelticiFaaliyet],
  page: {
    title: "İyileştirmeler",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit, formcombobox, formcheckbox,forminput,formdate,tableheader,BirimSecimi
  },
  data() {
    return {
      title: "Düzeltici Faaliyetin Onaylanması",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Kalite Yönetim Sistemi (ISO 9001) Çalışmaları",
        },
        {
          text: "Düzeltici Faaliyetin Onaylanması",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Filter: {
        Acanbirimid: null,
        Tespitsekliid: null,
        Acilisonay: null,
        Kapanisonay: null,
        No:null,
        Acilistarihbas: null,
        Acilistarihbit: null,
        Bitirmetarihbas: null,
        Bitirmetarihbit: null,
      },
      DetayId: null,
      OPersonelid: null,
      KaliteRoleKontrol:false, 
    };
  },

  methods: {
    Get() {
      if (this.OPersonelid) { this.TableGet() }

    },
    TableGet(OrderBy = "") {
      if(!OrderBy){ OrderBy = "Desc=No"}
      var Filter = ""
      if (this.Filter.Acanbirimid != null) { Filter += "&Acanbirimid=" + this.Filter.Acanbirimid }
      if (this.Filter.Tespitsekliid != null) { Filter += "&Tespitsekliid=" + this.Filter.Tespitsekliid }
      if (this.Filter.Acilisonay == true) { Filter += "&Acilisonay=" + this.Filter.Acilisonay }
      if (this.Filter.Kapanisonay == true) { Filter += "&Kapanisonay=" + this.Filter.Kapanisonay }
      if (this.Filter.No != null) { Filter += "&No=" + this.Filter.No }
      if (this.Filter.Acilistarihbas != null) { Filter += "&Acilistarihbas=" + this.Filter.Acilistarihbas }
      if (this.Filter.Acilistarihbit != null) { Filter += "&Acilistarihbit=" + this.Filter.Acilistarihbit }
      if (this.Filter.Bitirmetarihbas != null) { Filter += "&Bitirmetarihbas=" + this.Filter.Bitirmetarihbas }
      if (this.Filter.Bitirmetarihbit != null) { Filter += "&Bitirmetarihbit=" + this.Filter.Bitirmetarihbit }

      this.ActionsFilterGet({ Service: "StrIsoDuzelticiFaaliyet", Page: this.Page, Filter: Filter + "&" + OrderBy ?? "", }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },

    AcilisOnay(Data,durum) {
      Swal.fire({
        title: "Açılışı Onay " +( durum == false ? 'İptal' : ''),
        text: "Seçtiğiniz Faaliyetin açılış onay durumu değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Acilisonay = durum
          this.Update("StrIsoDuzelticiFaaliyet", Data, "Açılış durumu değiştirildi.")
        }
      });

    },
    KapanisOnay(Data,durum) {
      Swal.fire({
        title: "Kapanış Onay " +( durum == false ? 'İptal' : ''),
        text: "Seçtiğiniz Faaliyetin kapanışı onay durumu değiştiriliecek.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((result) => {
        if (result.value) {
          Data.Kapanisonay = durum
          this.Update("StrIsoDuzelticiFaaliyet", Data, "Kapanış durumu değiştirildi.")
        }
      });

    },
    
  isLink(text) {
    const urlPattern = /^(https?:\/\/|www\.)[^\s]+$/i;
    return urlPattern.test(text);
  },
    MuneRolesControl() {  
      let YetkiSorgu = this.UserRolles.filter((item) =>
        item.includes("SuperAdmin") || item.includes("StrAdmin") || item.includes("StrIsoKaliteTemsilci")
      );
      if (YetkiSorgu.length != 0) this.KaliteRoleKontrol = true; 
    },

  },
  async created() {

    let Page = {
      PageNumber: "1",
      PageSize: "1"
    }
    let Filter = "&Eposta=" + this.UserEMail;
    var res = await this.ActionsFilterGet({
      Service: "OPersonel",
      Page: Page,
      Filter: Filter,
    })
    this.OPersonelid = res.Data[0].Id;
    this.TableGet()
    this.MuneRolesControl();

  }
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">

                <formcombobox class="col-md-2" :FormDataType="FormDataType.Tespitsekliid" :Value="Filter.Tespitsekliid"
                  :v="$v.Filter.Tespitsekliid" @input="Filter.Tespitsekliid = $event" />

                <formcombobox class="col-md-2" :FormDataType="FormDataType.Acanbirimid" :Value="Filter.Acanbirimid"
                  :v="$v.Filter.Acanbirimid" @input="Filter.Acanbirimid = $event" v-if="0" />


        <BirimSecimi class="col-md-2"
                    :title="FormDataType.Acanbirimid.FieldTitle"
                    :sutun="'0'" 
                    :title_class="'mb-3'"
                    :selected="Filter.Acanbirimid" 
                    :v="$v.Filter.Acanbirimid"
                    :YetkiKontrol="1"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="Filter.Acanbirimid=$event"
                  />

                  
                <formdate class="col-md-2" :FormDataType='{ FieldName: "Acilistarihbas", Field: "textarea", FieldTitle: "Açılış Tarihi Başlangıç"}'
                  :v="$v.Filter.Acilistarihbas" @input="Filter.Acilistarihbas = $event" />
                <formdate class="col-md-2" :FormDataType='{ FieldName: "Acilistarihbit", Field: "textarea", FieldTitle: "Açılış Tarihi Bitiş"}'
                  :v="$v.Filter.Acilistarihbit" @input="Filter.Acilistarihbit = $event" />
                <formdate class="col-md-2" :FormDataType='{ FieldName: "Bitirmetarihbas", Field: "textarea", FieldTitle: "Bitirme Tarihi Başlangıç"}'
                  :v="$v.Filter.Bitirmetarihbas" @input="Filter.Bitirmetarihbas = $event" />
                <formdate class="col-md-2" :FormDataType='{ FieldName: "Bitirmetarihbit", Field: "textarea", FieldTitle: "Bitirme Tarihi Bitiş"}'
                  :v="$v.Filter.Bitirmetarihbit" @input="Filter.Bitirmetarihbit = $event" />
 


                <forminput class="col-md-1" :FormDataType='{ FieldName: "No", Field: "textarea", FieldTitle: "No"}'
                  :v="$v.Filter.No" @input="Filter.No = $event" />



                  <formcheckbox class="col-md-1"
                  :FormDataType='{ FieldName: "Acilisonay", Field: "checkbox", FieldTitle: "Açılış Onay" }'
                  :Value="Filter.Acilisonay" :v="$v.Filter.Acilisonay" @input="Filter.Acilisonay = $event" />
                <formcheckbox class="col-md-1"
                  :FormDataType='{ FieldName: "Kapanisonay", Field: "checkbox", FieldTitle: "Kapanış Onay" }'
                  :Value="Filter.Kapanisonay" :v="$v.Filter.Kapanisonay" @input="Filter.Kapanisonay = $event" />
<div class="col-md-2"></div>
        
                <div class="col-sm-2 ">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2 mt-4" @click="TableGet()"> <i
                      class="mdi mdi-text-search me-1"></i>Filtreleme</button>
                </div>



              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                   
                      <tableheader
                        @OrderBy="TableGet($event)"
                        :Data="[  
                          { No: 'DF No' },
                          { Acilistarih: 'DF Açılış Tarihi' }, 
                          { Acan: 'DF Açan Kişi' }, 
                          { Acanbirim: 'DF Açılan Birim' }, 
                          { Tespitsekli: 'Tespit Şekli' }, 
                          { Uyumsuzluktanim: 'Uygunsuzluk Tanımı' }, 
                          { Acilisonay: 'Açılış Onayı' }, 
                          { Yapiacakduzelticifaaliyet: 'Yapılacak Düzeltici Faaliyet' },  
                          { Ongorulenbitirmetarih: 'Öngörülen Bitirme Tarihi' }, 
                          { Onaylayan: 'DF Onaylayan Kişi' }, 
                          { Kanit: 'Kanıt' },
                          { Bitirmetarih: 'Bitirme Tarihi' }, 
                          { Kapanisonay: 'Kapanış Onayı' }, 
                        ]"
                      />
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.No }}</th>
                      <td>{{ Data.Acilistarih | formatDateTable }}</td>
                      <td>{{ Data.Acan }}</td>
                      <td>{{ Data.Acanbirim }}</td>
                      <td>{{ Data.Tespitsekli }}</td>
                      <td>{{ Data.Uyumsuzluktanim }}</td>
                      <td> 
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i class="fas fa-check" @click="AcilisOnay(Data,true)" v-if="Data.Acilisonay != true && KaliteRoleKontrol"></i>
                          <i class="fas fa-times" @click="AcilisOnay(Data,false)" v-if="Data.Acilisonay == true && KaliteRoleKontrol"></i> 
                        </div>
                      </td> 
                      <td>{{ Data.Yapiacakduzelticifaaliyet }}</td>
                      <td>{{ Data.Ongorulenbitirmetarih | formatDateTable }}</td>
                      <td>{{ Data.Onaylayan }}</td>
                      <td> 
 
                        <div class="row" v-for="(value, index) in JSON.parse(Data.Kanit)" :key="index"> 
                          <span  v-if="value.Tip == 'Text'  " > 
<a  v-if="isLink(value.Kanit)" :href="value.Kanit"  target="_blank" class="text-primary text-decoration-underline">
        {{ value.Kanit }} </a> 
<span v-else>{{ value.Kanit }}</span> 

                          </span>
                          <a v-if="value.Tip == 'File'" :href="$config.FILES_URL + 'str/' + value.Kanit" target="_blanl">
                            <i class="fas fa-eye" v-tooltip="'Dosya Görüntüle'"></i> {{ value.Kanit }}</a>
                        </div>

                      </td>
                      <td>{{ Data.Bitirmetarih | formatDateTable }}</td>
                      <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center"> 
                          <i v-b-tooltip.hover title="Kapanış Onay" class="fas fa-check" tooltip="Kapanış" @click="KapanisOnay(Data,true)" v-if="Data.Kapanisonay != true && Data.Acilisonay == true &&  Data.Bitirmetarih  && KaliteRoleKontrol"></i>
                          <i v-b-tooltip.hover title="Onay İptal" class="fas fa-times" @click="KapanisOnay(Data,false)" v-if="Data.Kapanisonay == true && KaliteRoleKontrol"></i>
                        </div></td>
                     
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                  :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="TableGet" :OPersonelid="OPersonelid" />


    </Layout>
  </Loader>
</template>
